//angular imports
import { Directive, OnInit, OnDestroy, input } from "@angular/core";

//rxjs imports
import { Subject, takeUntil } from "rxjs";

// Ignite imports
import {
  GridSelectionRange,
  IGridCellEventArgs,
  IGridEditEventArgs,
  IgxGridComponent,
} from "igniteui-angular";

//local imports
import { MatrixCellModel, MatrixGroupModel, MatrixRowProvider } from "@app/macd";

@Directive({
  selector: "[cell-selection]",
  standalone: false,
})
export class CellSelectionDirective implements OnInit, OnDestroy {
  private readonly destroying = new Subject<void>();

  public readonly rowProvider = input.required<any>();//TODO:DIW:Can we remove rowProvider, we have a grid ref, should be able to get rows from that?
  public readonly selectedCells: Set<MatrixCellModel> = new Set();

  constructor(private grid: IgxGridComponent){}
  
  ngOnInit() {
    this.setupGridEventListeners();
  }

  ngOnDestroy() {
    this.destroying.next();
    this.destroying.complete();
  }

  private setupGridEventListeners() {
    this.grid
      .selected.pipe(takeUntil(this.destroying))
      .subscribe((event: IGridCellEventArgs) => {
        this.handleCellSelected(event);
      });

    this.grid
      .cellEditExit.pipe(takeUntil(this.destroying))
      .subscribe((event: IGridEditEventArgs) => {
        this.handleCellEditExitSelection(event);
      });

    this.grid.rangeSelected.pipe(takeUntil(this.destroying))
          .subscribe((event: GridSelectionRange) => {
            this.handleRangeSelection(event);
          });
      }

  private handleCellSelected(event: IGridCellEventArgs) {
    let cellModel = this.getCellModel(event);

    if (!this.isMultiSelection(event)) {
      this.clearSelection();
    }

    this.updateCellSelection(cellModel, event.cell.selected);
  }

  private isMultiSelection(event: IGridCellEventArgs) {
    let mouseEvent = event.event as MouseEvent;

    if (mouseEvent?.ctrlKey) return true;
    if (mouseEvent?.shiftKey) return true;

    return false;
  }

  // This is called when cell is edited but not committed
  private handleCellEditExitSelection(event: IGridEditEventArgs) {
    let cellModel = this.getCellModel(event);
    this.updateCellSelection(cellModel, false);
  }

  //TODO:DUW:Make internal
  public clearSelection() {
    this.selectedCells.clear();
  }
  
  //TODO:DIW:Make internal
  public updateCellSelection(cellModel: MatrixCellModel, isSelected: boolean) {
    
    cellModel.isSelected.set(isSelected);

    if (isSelected && !this.selectedCells.has(cellModel)) 
    {
      this.selectedCells.add(cellModel);
    } 
    else if (!isSelected) {
      this.selectedCells.delete(cellModel);
    }
  }

  private handleRangeSelection(range: GridSelectionRange): void {
    let columns = this.getAvailableColumns();

    //TODO:DIW:Since we have a grid ref, is it possible to get the row without the provider
    for (let row: number = range.rowStart; row <= range.rowEnd; row++) {
      let rowModel = this.rowProvider().getRow(row);

      let cs: number = range.columnStart as number;
      let ce: number = range.columnEnd as number;

      

      for (let col: number = cs; col <= ce; col++) {
        if (col === 0) continue; //First column is a checkbox.
        let columnModel;
        if(this.rowProvider().filteredGroups().length >= 2 &&
            this.rowProvider().filteredGroups()[0].canEdit() &&
            this.rowProvider().filteredGroups()[1].canEdit())
        {
            columnModel = columns[col-1];  
        }else{
            columnModel = columns[col];
        }
       
        let cellModel = rowModel[columnModel.id];

        this.updateCellSelection(cellModel, true);
      }
    }
  }

  private getCellModel(event: IGridCellEventArgs | IGridEditEventArgs) {
    let rowData = "cell" in event ? event.cell.row.data : event.rowData;
    let field = "cell" in event ? event.cell.column.field : event.column.field;

    return rowData.value()[field] as MatrixCellModel;
  }

  private getAvailableColumns() {
    //TODO:DIW:Can we use the grid ref to get columns directly?
    let provider = this.rowProvider();
    return provider
        ?.currentScope()
        ?.groups()
        ?.flatMap((group: MatrixGroupModel) => group.columns()) || [];
  }

}
